export default "__VITE_ASSET__BuBv5yCa__"